export default "__VITE_ASSET__BoAqm23E__"